import './Modal.css';

const Modal = (props) => {
  return (
    <div onClick={props.closeFn ? () => props.closeFn(props.closeCallback) : null} className="ModalOverlay">
      <div
        className="Modal"
        onClick={(e) => {
          e.stopPropagation();
        }}>
        {props.children}
      </div>
    </div>
  );
};

export default Modal;
